"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueValidation = exports.ValueValidationError = void 0;
var lodash_1 = require("lodash");
var ValueValidationError = /** @class */function (_super) {
  __extends(ValueValidationError, _super);
  function ValueValidationError(message, expression, value) {
    var _newTarget = this.constructor;
    var _this =
    // 'Error' breaks prototype chain here
    _super.call(this, message) || this;
    _this.message = message;
    _this.expression = expression;
    _this.value = value;
    // restore prototype chain
    var actualProto = _newTarget.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(_this, actualProto);
    } else {
      _this.__proto__ = actualProto;
    }
    var _value = _this.internalValueView(value);
    _this.description = "Expression ".concat(expression, " = ").concat(_value, " not valid, ").concat(message);
    try {
      if ('captureStackTrace' in Error) {
        Error.captureStackTrace(_this);
      }
    } catch (e) {
      // ? this.stack = e.stack;
    }
    return _this;
  }
  Object.defineProperty(ValueValidationError.prototype, "name", {
    // restore prototype chain after `super(message)`
    get: function () {
      return this.constructor.name;
    },
    enumerable: false,
    configurable: true
  });
  ValueValidationError.prototype.internalValueView = function (value) {
    return JSON.stringify(value);
  };
  return ValueValidationError;
}(Error);
exports.ValueValidationError = ValueValidationError;
var ValueValidation = /** @class */function () {
  function ValueValidation() {}
  ValueValidation.isUUIDv4 = function (value) {
    return ValueValidation.regexUUIDv4.test(value);
  };
  ValueValidation.isEmail = function (value) {
    return ValueValidation.regexEmail.test(value);
  };
  ValueValidation.assertEmail = function (expression, value) {
    if (!ValueValidation.isEmail(value)) {
      throw new ValueValidationError('Expected email value', expression, value);
    }
  };
  ValueValidation.assertUUIDv4 = function (expression, value) {
    if (!ValueValidation.isUUIDv4(value)) {
      throw new ValueValidationError('`Expected UUID (v4) value', expression, value);
    }
  };
  ValueValidation.assertDate = function (expression, value) {
    if (value instanceof Date) {
      /*
       * Если дата не валидная
       * value.getTime() = NaN
       * value.toString() = 'Invalid date'
       *
       * @see https://stackoverflow.com/a/67410020/3544196
       */
      if (isNaN(value)) {
        throw new ValueValidationError('Expected Date value', expression, value);
      }
    } else if ((0, lodash_1.isNumber)(value) || (0, lodash_1.isString)(value)) {
      ValueValidation.assertDate(expression, new Date(value));
    } else {
      throw new ValueValidationError('Expected Date value', expression, value);
    }
  };
  ValueValidation.assertString = function (expression, value) {
    if (!(0, lodash_1.isString)(value)) {
      throw new ValueValidationError('Expected String value', expression, value);
    }
  };
  ValueValidation.assertStringMinLength = function (expression, value, min_length) {
    if (min_length === void 0) {
      min_length = 1;
    }
    ValueValidation.assertString(expression, value);
    if (value.length < min_length) {
      throw new ValueValidationError("Expected String ".concat(min_length, " length minimum"), expression, value);
    }
  };
  ValueValidation.assertStringMaxLength = function (expression, value, max_length) {
    if (max_length === void 0) {
      max_length = 1;
    }
    ValueValidation.assertString(expression, value);
    if (value.length > max_length) {
      throw new ValueValidationError("Expected String ".concat(max_length, " length maximum"), expression, value);
    }
  };
  ValueValidation.assertTrue = function (expression, value) {
    if (value !== true) {
      throw new ValueValidationError('Expected Boolean True value', expression, value);
    }
  };
  ValueValidation.assertFalse = function (expression, value) {
    if (value !== false) {
      throw new ValueValidationError('Expected Boolean False value', expression, value);
    }
  };
  ValueValidation.assertInteger = function (expression, value) {
    if (!(0, lodash_1.isInteger)(value)) {
      throw new ValueValidationError('Expected Integer value', expression, value);
    }
  };
  ValueValidation.assertBoolean = function (expression, value) {
    if (!(value === false || value === true)) {
      throw new ValueValidationError('Expected Boolean value', expression, value);
    }
  };
  ValueValidation.assertDefined = function (expression, value) {
    if (!value) {
      // -> 0, false, undefined, null, ''
      throw new ValueValidationError('Expected defined value', expression, value);
    }
  };
  ValueValidation.assertNotEmpty = function (expression, value) {
    if ((0, lodash_1.isArray)(value)) {
      if (!value.length) {
        throw new ValueValidationError('Expected non-empty Array value', expression, value);
      }
      value.map(function (element, index) {
        return ValueValidation.assertDefined("".concat(expression, "[").concat(index, "]"), element);
      });
      return;
    }
    if ((0, lodash_1.isObject)(value)) {
      if (!Object.keys(value).length) {
        throw new ValueValidationError('Expected non-empty Object value', expression, value);
      }
      Object.keys(value).map(function (prop) {
        // @ts-ignore
        return ValueValidation.assertDefined("".concat(expression, ".").concat(prop), value[prop]);
      });
      return;
    }
    if ((0, lodash_1.isString)(value)) {
      ValueValidation.assertStringMinLength(expression, value, 1);
      return;
    }
    ValueValidation.assertDefined(expression, value);
  };
  ValueValidation.regexUUIDv4 = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;
  // https://emailregex.com/
  // eslint-disable-next-line max-len
  ValueValidation.regexEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return ValueValidation;
}();
exports.ValueValidation = ValueValidation;
